
import { Component, Vue, Prop } from 'nuxt-property-decorator'
import BlogShare from '~/components/BlogShare.vue'
import RatingStars from '~/components/sections/rating/RatingStars.vue'

@Component({
  components: {
    BlogShare,
    RatingStars,
  },
})
export default class StudyCaseBody extends Vue {
  @Prop({ type: String, default: '' })
  private logoSrc!: string

  @Prop({ type: String, default: '' })
  private title!: string
}
